export const routes = (parentName) => {
  return [
    {
      path: "event-registered",
      component: () => import("./Index.vue"),
      children: [
        {
          path: "",
          name: `${parentName}-EventRegistered`,
          component: () => import("./List.vue"),
          props: (route) => ({
            step: route.query.step,
          }),
        },
        {
          path: "new",
          name: `${parentName}-EventRegistered-New`,
          component: () => import("./Upsert.vue"),
        },
        {
          path: ":id",
          name: parentName + "-" + "EventRegistered-View",
          component: () => import("./View.vue"),
        },
        {
          path: ":id/edit",
          name: parentName + "-" + "EventRegistered-Edit",
          component: () => import("./Upsert.vue"),
        },
      ],
    },
  ];
};
